<div [formGroup]="form">
  <!-- Seção Outros -->
  <div class="section-container" id="outros">
    <div class="section-title">
      <mat-icon>more_horiz</mat-icon>
      <span>Outros</span>
    </div>

    <div class="row">
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Unidade por Caixa</mat-label>
          <input matInput formControlName="unidadePorCaixa" [currencyMask]="quantidadeMask" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        @if (listaLinhaProduto) {
        <app-select-pesquisavel label="Linha de Produto" [offlineList]="listaLinhaProduto"
          [control]="idLinhaProdutoControl" idField="id" nameField="descricao">
        </app-select-pesquisavel>
        }
      </div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Garantia</mat-label>
          <input matInput formControlName="garantiaTexto" placeholder="Ex: 12 meses" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3 d-flex align-items-center">
        <mat-slide-toggle class="app-toggle-compact" formControlName="isPermitirVenda">Permitir inclusão nas
          vendas</mat-slide-toggle>
      </div>
    </div>

    <!-- Controle de múltiplo: só para produto que não é Kit (RN04) -->
    @if (!isKit) {
    <div class="row">
      <div class="col-12 d-flex align-items-center">
        <mat-slide-toggle class="app-toggle-compact" formControlName="isControlaMultiplo">Controla
          múltiplos</mat-slide-toggle>
      </div>
    </div>

    @if (isControlaMultiplo) {
    <h4 class="subsection-title">Controle de múltiplo</h4>
    <p class="multiplo-apoio">
      Este produto é vendido em embalagem fechada — caixa, fardo, pacote ou saco. A quantidade é
      informada em embalagens e o sistema converte para a unidade de venda, impedindo quantidades
      que não fecham a embalagem.
    </p>
    <div class="row">
      <div class="col-12 col-md-4">
        @if (listaUnidadeMedida) {
        <app-select-pesquisavel label="Unidade de múltiplo" [offlineList]="listaUnidadeMultiplo"
          [control]="idUnidadeMultiploControl" idField="idUnidadeMedida" nameField="descricao"
          placeholder="Selecione...">
        </app-select-pesquisavel>
        }
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fator do múltiplo</mat-label>
          <input matInput class="text-end" formControlName="fatorMultiplo" [currencyMask]="quantidadeMask" />
          <mat-icon class="material-symbols-outlined"
            matTooltip="Quanto a embalagem contém na unidade de venda do produto" matSuffix>info</mat-icon>
          @if (form.get('fatorMultiplo')?.hasError('required')) {
          <mat-error> Preenchimento obrigatório </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <!-- Atenção quando só um dos dois campos está preenchido (CA04/CA05) -->
    @if (alertaMultiploTexto) {
    <app-alert-card type="warning">{{ alertaMultiploTexto }}</app-alert-card>
    }
    @if (mostrarConversaoMultiplo) {
    <p class="multiplo-conversao">
      1 {{ abreviacaoUnidadeMultiplo }} = {{ form.get('fatorMultiplo')?.value | abnt: 'quantidade' }} na unidade de
      venda do produto.
    </p>
    }
    <p class="multiplo-apoio">
      A <strong>unidade de múltiplo</strong> é a embalagem em que o produto sai do estoque. O
      <strong>fator</strong> é quanto essa embalagem contém na unidade de venda — uma caixa com 100
      unidades tem fator 100; uma caixa de porcelanato com 2,58 m² tem fator 2,58.
    </p>
    }
    }

    <div class="row">
      <div class="col-12">
        @if (listaTag) {
        <app-select-pesquisavel label="Tags" [offlineList]="listaTag" [control]="tagsControl" idField="idTag"
          nameField="nome" [corField]="'cor'" [multiple]="true" [showBadges]="true" placeholder="Selecione...">
        </app-select-pesquisavel>
        }
      </div>
    </div>

    <h4 class="subsection-title">Informações Tributárias Adicionais</h4>
    <div class="row">
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>GTIN/EAN Tributável</mat-label>
          <input matInput formControlName="gtinTributavel" [mask]="masks.gtinEan" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        @if (listaUnidadeMedida) {
        <app-select-pesquisavel label="Unidade Tributável" [offlineList]="listaUnidadeMedida"
          [control]="idUnidadeTributavelControl" idField="idUnidadeMedida" nameField="descricao">
        </app-select-pesquisavel>
        }
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fator de Conversão</mat-label>
          <input matInput formControlName="fatorConversao" [currencyMask]="quantidadeMask" />
          <mat-icon class="material-symbols-outlined" matTooltip="Obrigatório quando a unidade tributável for diferente da unidade de medida"
            matSuffix>info</mat-icon>
          @if (form.get('fatorConversao')?.hasError('required')) {
          <mat-error> Preenchimento obrigatório </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Cód. Enquadramento IPI</mat-label>
          <input matInput formControlName="codigoEnquadramentoIpi" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Valor IPI Fixo</mat-label>
          <input matInput formControlName="valorIpiFixo" [currencyMask]="defaultCurrencyMask" min="0" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>EX TIPI</mat-label>
          <input matInput formControlName="exTipi" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Aliq. Imposto Seletivo (%)</mat-label>
          <input matInput formControlName="aliqImpostoSeletivo" [currencyMask]="percentageMask" min="0" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Qtd Tributada Monofasia</mat-label>
          <input matInput formControlName="qtdTributadaMonofasia" [currencyMask]="quantidadeMask" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Qtd Tributada Retenção</mat-label>
          <input matInput formControlName="qtdTributadaRetencaoMonofasia" [currencyMask]="quantidadeMask" />
        </mat-form-field>
      </div>
    </div>

    <!-- ── Dados ANP (exibido quando o NCM está mapeado na Tabela ANP) ── -->
    @if (anpMatch) {
    <h4 class="subsection-title anp-title">
      <mat-icon>local_gas_station</mat-icon>
      Dados ANP
      <span class="anp-chip">Produto sujeito à ANP</span>
    </h4>
    <p class="anp-hint">
      Seção exibida automaticamente porque o NCM <strong>{{ anpMatch.codigoNcm }}</strong>
      está mapeado na Tabela ANP ({{ anpMatch.nivel }}). Informe o Código ANP correspondente —
      os demais atributos são lidos em tempo real da Tabela ANP.
    </p>
    <div class="row align-items-stretch">
      <div class="col-12 col-md-5">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Código ANP</mat-label>
          <mat-select formControlName="idAnpEmpresa" (selectionChange)="onAnpSelecionado($event.value)"
            placeholder="Selecione o Código ANP">
            @for (c of codigosAnp; track c.idAnpEmpresa) {
            <mat-option [value]="c.idAnpEmpresa">{{ c.codigo }} — {{ c.descricao }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-7">
        <div class="anp-card">
          @if (anpSelecionado) {
          <div class="anp-card-head">
            <span class="anp-card-title">Atributos do Código ANP</span>
            <span class="anp-card-lock"><mat-icon>lock</mat-icon> Somente leitura</span>
          </div>
          <div class="anp-card-body">
            <div class="anp-field anp-field-strong">
              <span class="anp-field-label">Descrição ANP</span>
              <span class="anp-field-value">{{ anpSelecionado.descricao }}</span>
            </div>
            <div class="anp-field anp-field-strong">
              <span class="anp-field-label">Unidade</span>
              <span class="anp-field-value">{{ unidadeAbreviacao(anpSelecionado.idUnidadeMedida) }}</span>
            </div>
            <div class="anp-field">
              <span class="anp-field-label">Regime ICMS</span>
              <span class="status-badge badge-azul">{{ anpSelecionado.regimeIcmsDescricao }}</span>
            </div>
            <div class="anp-field">
              <span class="anp-field-label">
                Alíquota ad rem do ICMS
                <mat-icon class="anp-info" matTooltip="Alíquota ad rem do ICMS por unidade tributável, lida da Tabela ANP.">info</mat-icon>
              </span>
              <span class="anp-field-value">
                R$ {{ anpSelecionado.aliquotaIcmsPorUnidade | number:'1.4-4' }} / {{ unidadeAbreviacao(anpSelecionado.idUnidadeMedida) }}
              </span>
            </div>
            <div class="anp-field">
              <span class="anp-field-label">
                Exige pBio
                <mat-icon class="anp-info" matTooltip="Exige o percentual de mistura de biocombustível (pBio) na emissão da NF-e.">info</mat-icon>
              </span>
              <span class="status-badge" [class.badge-verde]="anpSelecionado.exigePbio" [class.badge-cinza]="!anpSelecionado.exigePbio">
                {{ anpSelecionado.exigePbio ? 'Sim' : 'Não' }}
              </span>
            </div>
            <div class="anp-field">
              <span class="anp-field-label">
                Exige Grupo GLP
                <mat-icon class="anp-info" matTooltip="Exige pGLP, pGNn, pGNi e vPart na emissão da NF-e (aplicável ao GLP).">info</mat-icon>
              </span>
              <span class="status-badge" [class.badge-verde]="anpSelecionado.exigeGrupoGlp" [class.badge-cinza]="!anpSelecionado.exigeGrupoGlp">
                {{ anpSelecionado.exigeGrupoGlp ? 'Sim' : 'Não' }}
              </span>
            </div>
          </div>
          <div class="anp-card-foot">
            <span class="anp-card-foot-note">Lido em tempo real da Tabela ANP</span>
            <a class="anp-link" routerLink="/configuracoes/notas-fiscais/tabela-anp" target="_blank">
              Ver na Tabela ANP <mat-icon>open_in_new</mat-icon>
            </a>
          </div>
          } @else {
          <div class="anp-placeholder">
            <mat-icon>touch_app</mat-icon>
            Selecione um Código ANP para visualizar seus atributos oficiais.
          </div>
          }
        </div>
      </div>
    </div>
    }

    <!-- ── Informações referentes a medicamentos (ANVISA, NCM 3004) ── -->
    @if (showMedicamento) {
    <h4 class="subsection-title">Informações referentes a medicamentos</h4>
    <div class="row">
      <div class="col-12">
        <mat-slide-toggle class="app-toggle-compact" [checked]="isIsentoAnvisa"
          (change)="onToggleIsento($event.checked)">
          Produto isento de código ANVISA
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row">
      @if (!isIsentoAnvisa) {
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Código ANVISA</mat-label>
          <input matInput formControlName="codigoAnvisa" placeholder="Nº de registro ANVISA" />
        </mat-form-field>
      </div>
      } @else {
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Motivo da isenção</mat-label>
          <input matInput formControlName="motivoIsencaoAnvisa" maxlength="255"
            placeholder="Informe o motivo da isenção" />
          @if (motivoIsencaoAnvisaControl?.hasError('required') && motivoIsencaoAnvisaControl?.touched) {
          <mat-error>Informe o motivo da isenção.</mat-error>
          }
        </mat-form-field>
      </div>
      }
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Valor Máximo (PMC)</mat-label>
          <input matInput formControlName="valorMaximoPmc" [currencyMask]="defaultCurrencyMask" />
        </mat-form-field>
      </div>
    </div>
    }

    <div formArrayName="fornecedores">
      <div class="d-flex justify-content-between align-items-center mb-2 mt-2">
        <h4 class="subsection-title mb-0">Fornecedores</h4>
        <button mat-button type="button" (click)="addFornecedorRow()">
          <mat-icon>add</mat-icon> Adicionar
        </button>
      </div>

      @for (item of fornecedores.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="row fornecedor-row">
          <div class="col-10 col-md-11">
            <div class="row">
              <div class="col-12 col-lg-7">
                <app-select-pesquisavel [apiUrl]="urlFornecedor" [control]="getControl(item, 'idFornecedor')"
                  idField="id" nameField="descricao" label="Fornecedor" placeholder="Pesquise o fornecedor...">
                </app-select-pesquisavel>
              </div>
              <div class="col-6 col-lg-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Código no Fornecedor</mat-label>
                  <input matInput formControlName="codigoNoFornecedor" placeholder="Código..." />
                </mat-form-field>
              </div>
              <div class="col-6 col-lg-2 fornecedor-principal-col">
                <mat-slide-toggle (change)="setFornecedorPrincipal(i, $event)"
                  [checked]="item.get('isPrincipal')?.value" formControlName="isPrincipal">Fornecedor
                  Principal</mat-slide-toggle>
              </div>
            </div>
          </div>

          <div class="col-2 col-md-1 delete-col produto-grid-delete-col">
            <button mat-icon-button class="produto-grid-delete-button" type="button" (click)="removeFornecedorRow(i)"
              matTooltip="Remover">
              <mat-icon class="material-symbols-outlined">delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
      }

      @if (fornecedores.touched && fornecedores.hasError('minArrayLength')) {
      <mat-error class="produto-obrigatorio-erro" tabindex="-1">Vincule ao menos um fornecedor</mat-error>
      }
      @if (fornecedores.length === 0) {
      <app-empty-state icon="local_shipping" title="Nenhum fornecedor cadastrado."
        subtitle="Fornecedores permitem registrar de quem este produto é comprado e o código usado por eles.">
      </app-empty-state>
      }
    </div>

    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Observações Gerais</mat-label>
          <textarea matInput formControlName="observacoesGerais" rows="3"></textarea>
        </mat-form-field>
      </div>
    </div>

    <h4 class="subsection-title">Atributos para Motores de Busca (SEO)</h4>
    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Link do Vídeo</mat-label>
          <input matInput formControlName="seoLinkVideo" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Slug</mat-label>
          <input matInput formControlName="seoSlug" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Keywords</mat-label>
          <input matInput formControlName="seoKeywords" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Título (SEO)</mat-label>
          <input matInput formControlName="seoTitulo" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Descrição (SEO)</mat-label>
          <textarea matInput formControlName="seoDescricao" rows="2" maxlength="255"></textarea>
          <mat-hint align="end">{{ form.get('seoDescricao')?.value?.length || 0 }} / 255</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
